// Header.js
import { useNavigate } from "react-router-dom";
import "./header.component.scss";
import { useDispatch } from "react-redux";
import { logout } from "../../state/slice";
import useApi from "../../hooks/useApi";
const Header = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const { post } = useApi();

  const logoutNow = () => {
    logoutUser();
   
  };

  const logoutUser = async () => {
    
      const response: any = await post("/logout");
      console.log(response);
      // if (
      //   response?.data?.email &&
      //   response?.data?.name &&
      //   response?.data?.password
      // ) {
      //   dispatch(logout());
      // } else {
      
      // }
      dispatch(logout());
      navigate("/");
    };
  return (
    <header className="headerClass">
      <button
        className=" logoutbtn  w-sm-25 w-md-25"
        type="submit"
        title="Logout"
        onClick={logoutNow}
      >
        Logout
      </button>
    </header>
  );
};

export default Header;
